/* eslint-disable max-lines-per-function */
import React from "react";
import { Button } from "antd";
import AdReportForm from "../AdReportForm";
import SellerInfo from "../SellerInfo";
import PhoneNumberButton from "../PhoneNumberButton";
import AdLocationMap from "../../AdLocationMap/AdLocationMap";
import { getIconUrl } from "../../../../services/asset";
import { FlagIcon } from "./FlagIcon";
import styles from "./sellerSection.scss";
import { ButtonType, HrCountryId, ModuleNameHr } from "../../../../models";
import GoogleAd from "../../../../components/GoogleAd";
import { googleAds } from "appConfig";
import { useSelector } from "react-redux";
import { selectForbidAds } from "../../../../routes/Ad/ad.ducks";
import { SHOULD_SHOW_OPEN_LAYER_MAPS } from "../../../../constants";
import { SocialMediaLinks } from "../../SocialMediaLinks/SocialMediaLinks";
import ReactGA from "react-ga4";
import { RealEstateWidget } from "../../../ModulePage/RealEstatePricesEntryBox/RealEstateWidget";
import { isPropertyTypeSlug } from "../../../RealEstatePricesPage/helpers";
import { selectCurrentCategories } from "../../../App/selectors";

export const externalPartner = "Adriatic.hr";

const SellerSection = (props: any) => {
  const {
    disabled,
    adCreator,
    isReportVisible,
    onReportClose,
    onReportSubmit,
    onReportOpen,
    adSummary,
    category,
    handleContactClick,
    user,
    module,
    hideContact,
    topSlot,
  } = props;

  const forbiddAds = useSelector(selectForbidAds);
  const currentCategories = useSelector(selectCurrentCategories)

  // Location names come with the ad summary (countryName, countyName, cityName, settlementName)
  const constructAddress = () => {
    if (!adSummary) {
      return null;
    }

    if (adSummary.countryId && adSummary.countryId !== HrCountryId) {
      return { settlementName: adSummary.countryName || "", address: "" };
    }

    const address = [adSummary.cityName, adSummary.countyName].filter(Boolean).join(", ");

    if (!address) return { settlementName: adSummary.countryName || "", address };

    return { address, settlementName: adSummary.settlementName || "" };
  };

  const address = constructAddress();
  const shouldShowSendMessageButton = user ? adCreator && (adCreator.id !== user.userId) : true

  return (
    <div className={styles.wrapSellerSection}>
      {topSlot}
      {!hideContact && (
        <div
          className={`${styles.sellerSection} ${disabled ? styles.disabled : ""}`}
        >
          <div className={styles.wrapSection}>
            <div className={styles.sellerInfo}>
              {adCreator && (
                <SellerInfo
                  adCreator={adCreator}
                  category={category}
                  position={ButtonType.top}
                  adId={adSummary.id}
                />
              )}
            </div>

            <AdReportForm
              visible={isReportVisible}
              onCancel={onReportClose}
              onCreate={onReportSubmit}
            />

            <div className={styles.buttonSection}>
              <div>
                <SocialMediaLinks seller={adCreator} />
                {adCreator && adCreator.isVerified && (
                  <div className={styles.verfiedNumbers}>
                    <img
                      className={styles.verifyBadge}
                      src={getIconUrl("verified.svg")}
                      alt="verified-badge"
                    />
                    <p className={styles.info}>{"Verificiran broj telefona"}</p>
                  </div>
                )}
                <PhoneNumberButton
                  category={category}
                  hasPhones={adSummary.hasPhones}
                  adId={adSummary.id}
                />
                {shouldShowSendMessageButton && <Button
                  className={styles.sendEmailButton}
                  onClick={handleContactClick}
                >
                  Pošalji poruku
                </Button>}
                {adCreator && adCreator.replyStatisticsMessage && (
                  <p className={styles.replyStatistics}>{adCreator.replyStatisticsMessage}</p>
                )}

                {adCreator && externalPartner == adCreator.username && (
                  <Button
                    className={styles.externalLink}
                    type="ghost"
                    target="_blank"
                    href={adSummary.externalUrl}
                    onClick={() => {
                      ReactGA.event({
                        category: "Turizam",
                        action: "Click",
                        label: "Rezerviraj iz oglasa"
                      });
                    }}
                  >
                    {"Rezerviraj"}
                  </Button>
                )}

                <a
                  role="button"
                  tabIndex={0}
                  onClick={onReportOpen}
                  className={styles.report}
                >
                  <FlagIcon className={styles.flag} />
                  {"Prijavi oglas"}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {adSummary && adSummary.locationScope && adSummary.locationScope !== 1 ? (
        // V2OGLASI-2648: Jobs/Services ads can target a wider area than a
        // single settlement. The label switches to „Područje rada" /
        // „Područje pružanja usluge"; the value is the comma-separated
        // locationName the BE already builds. No map — these ads don't
        // have precise coordinates.
        <div className={styles.bottomSection}>
          <div className={styles.local}>
            {module === ModuleNameHr.jobs
              ? "Područje rada"
              : module === ModuleNameHr.services
                ? "Područje pružanja usluge"
                : "Lokacija"}
          </div>
          <div className={styles.bottomCard}>
            <b>{adSummary.locationName}</b>
          </div>
        </div>
      ) : (address && (address.address || address.settlementName)) ? (
        <div className={styles.bottomSection}>
          <div className={styles.local}>{"Lokacija"}</div>
          <div className={styles.bottomCard}>
            {address.settlementName ? (
              <b>{address.settlementName}</b>
            ) : null}
            {address.address ? (
              <div className={styles.bottomAddress}>{address.address}</div>
            ) : null}
          </div>
          {SHOULD_SHOW_OPEN_LAYER_MAPS && <AdLocationMap adSummary={adSummary} />}
        </div>
      ) : null}
      {module === ModuleNameHr.realEstate && isPropertyTypeSlug(category, currentCategories) && (
        <RealEstateWidget
          category={category}
          style={{ maxWidth: "none", marginTop: 20 }}
          label="Box detalji oglasa desktop"
        />
      )}
      {!forbiddAds && (<div style={{ margin: "0 auto", marginTop: 15 }}>
        <GoogleAd
          config={{
            ...googleAds.detailPage.right,
            id: "googleAds.detailPage.right"
          }}
        />
      </div>)}
    </div>
  );
};

SellerSection.defaultProps = {
  adCreator: null,
  isReportVisible: false,
  disabled: false,
  hideContact: false,
  topSlot: null
};

export default SellerSection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SellerSection/SellerSection.tsx